import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig, ReportDownloadTypes } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  SurgeryStatsReportTableComponentModule,
  SurgeryStatsReportTableComponent
} from './components/surgery-stats-report-table/surgery-stats-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-surgery-stats-report',
  templateUrl: './surgery-stats-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    SurgeryStatsReportTableComponent,
    AsyncPipe,
    TranslateModule
  ]
})
export class SurgeryStatsReportComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'SURGERY_STATS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true
    },
    filters: {
      groupByScope: true,
      recordDate: true,
      age: true,
      geography: true,
      periodType: true,
      periodPresets: true,
      organizationsTree: true,
      treatmentStatus: true,
      exclusions: true,
      mohGrades: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList('SURGERY_STATS', this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    ReportFiltersModule,
    CommonModule,
    SurgeryStatsReportTableComponentModule,
    TranslateModule,
    GeneralCommonsModule,
    SurgeryStatsReportComponent
  ],
  exports: [SurgeryStatsReportComponent]
})
export class SurgeryStatsReportComponentModule {}
